import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import DevoteeDonationsReports from './devoteeDonationsReports';
import PoojaReports from './pooja/poojaReports';
import PriestReports from './priest/priestReports';
import TreasuryReports from './treasury/treasuryReports';
import SystemReports from './systemReports/systemReports';
import DevoteeSponsorshipReports from './devoteeSponsorship/devoteeSponsorshipReports';
import DevoteeReports from './devotee/devoteeReports';
import Volunteers from './volunteers';
import EventRegstration from './eventRegstration';
import { SubRoutingURLs } from "../common/RoutingURLs";
import FrontDesk from './frontDesk/frontDeskReports';
import { Toaster } from 'react-hot-toast';
import VolunteerParentFile from './Volunteers/VolunteerParentFile';

const ReportSectionRouters: React.FunctionComponent = () => {
    const { reportSectionType } = useParams();

    let componentToRender: JSX.Element;

    const { state } = useLocation();
    const subRoutes = state?.subRoutes;
    switch (reportSectionType) {
       
        case SubRoutingURLs.DEVOTEE_SPONSORSHIP_REPORTS:
            componentToRender = <DevoteeSponsorshipReports subReports={subRoutes}/>;
            break;
        case 'Devotee Donations Reports':
            componentToRender = <DevoteeDonationsReports />;
            break;
        case SubRoutingURLs.POOJA_REPORTS:
            componentToRender = <PoojaReports subReports={subRoutes}/>;
            break;
        case SubRoutingURLs.PRIEST_REPORTS:
            componentToRender = <PriestReports subReports={subRoutes}/>;
            break;
        case SubRoutingURLs.TREASURY_REPORTS:
            componentToRender = <TreasuryReports subReports={subRoutes}/>;
            break;
        case SubRoutingURLs.DEVOTEE_INFORMATION:
            componentToRender = <DevoteeReports subReports={subRoutes}/>;
            break;
        case SubRoutingURLs.SYSTEM_REPORTS:
            componentToRender = <SystemReports subReports={subRoutes}/>;
            break;
        case 'Event Regstration':
            componentToRender = <EventRegstration />;
            break;
        case SubRoutingURLs.FRONT_DESK:
            componentToRender = <FrontDesk subReports={subRoutes}/>;
            break;
        case SubRoutingURLs.VOLUNTEERS:
            componentToRender = <VolunteerParentFile subReports={subRoutes}/>;
            break;
        default:
            componentToRender = <div>Page not found</div>;
    }

    return (
      <>
        <Toaster />
        {componentToRender}
      </>
    );
};

export default ReportSectionRouters